import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { NEWS_FEATURE_KEY } from './keys';
import { newsReducer } from './reducers/news.reducer';
import { NewsEffects } from './effects/news.effects';

export const newsStoreProviders = [provideState(NEWS_FEATURE_KEY, newsReducer), provideEffects(NewsEffects)];

export { NewsFacade } from './facade/news.facade';
export { News } from './models';
